export default "__VITE_ASSET__Dc1J7Qrm__"